import Model, { attr } from '@ember-data/model';

export default class TntConnectImportModel extends Model {
  @attr('string') importType?: 'datasync' | 'xml';
  @attr('string') s3Key?: string;
  @attr('boolean') includeGifts?: boolean;
  @attr('boolean') includeTasks?: boolean;
  @attr('boolean') includeHistory?: boolean;
  @attr('boolean') includeGroups?: boolean;
  @attr('boolean') includePledges?: boolean;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'tnt-connect-import': TntConnectImportModel;
  }
}
